import type { GameSnapshot } from '../shared/types.js';
import { byId } from './controllerDom.js';
import { createFrostLayer, type FrostLayer } from './effects/frostOverlayEffect.js';

let controllerEmpFlashOverlay: HTMLDivElement | null = null;
let controllerPowerFlickerOverlay: HTMLDivElement | null = null;
let controllerFrostOverlay: HTMLElement | null = null;
let controllerFrostLayer: FrostLayer | null = null;

/** Cabin temperature (C) at which the first frost forms, and where the glass is fully frosted. */
const FROST_START_C = -8;
const FROST_FULL_C = -50;
/** >1 makes the early frost slower to build than a straight line would. */
const FROST_GROWTH_CURVE = 1.5;
let controllerHeatOverlay: HTMLElement | null = null;

export const initializeControllerEffects = (): void => {
  if (controllerEmpFlashOverlay) {
    return;
  }

  controllerEmpFlashOverlay = document.createElement('div');
  controllerEmpFlashOverlay.style.position = 'fixed';
  controllerEmpFlashOverlay.style.inset = '0';
  controllerEmpFlashOverlay.style.pointerEvents = 'none';
  controllerEmpFlashOverlay.style.background = 'rgba(255,255,255,0.88)';
  controllerEmpFlashOverlay.style.opacity = '0';
  controllerEmpFlashOverlay.style.transition = 'opacity 0.22s ease-out';
  controllerEmpFlashOverlay.style.zIndex = '99999';
  controllerEmpFlashOverlay.style.mixBlendMode = 'screen';
  document.body.appendChild(controllerEmpFlashOverlay);

  controllerPowerFlickerOverlay = document.createElement('div');
  controllerPowerFlickerOverlay.style.position = 'fixed';
  controllerPowerFlickerOverlay.style.inset = '0';
  controllerPowerFlickerOverlay.style.pointerEvents = 'none';
  controllerPowerFlickerOverlay.style.background = '#000';
  controllerPowerFlickerOverlay.style.opacity = '0';
  controllerPowerFlickerOverlay.style.zIndex = '99998';
  document.body.appendChild(controllerPowerFlickerOverlay);

  controllerFrostOverlay = byId<HTMLElement>('controllerFrostOverlay');
  controllerHeatOverlay = byId<HTMLElement>('controllerHeatOverlay');

  if (controllerFrostOverlay) {
    controllerFrostLayer = createFrostLayer(controllerFrostOverlay);
  }
};

export const triggerPowerFailureLightsFlicker = (): void => {
  const overlay = controllerPowerFlickerOverlay;
  if (!overlay) {
    return;
  }

  overlay.style.animation = 'none';
  overlay.style.opacity = '0';
  void overlay.offsetWidth;
  overlay.style.animation = 'powerFailureFlicker 2s forwards';
  window.setTimeout(() => {
    overlay.style.animation = 'none';
    overlay.style.opacity = '0';
  }, 2100);
};

export const updateTemperatureEffects = (snapshot: GameSnapshot): void => {
  if (controllerFrostOverlay) {
    const linear = (FROST_START_C - snapshot.submarine.insideTemperature) / (FROST_START_C - FROST_FULL_C);
    const frostProgress = Math.pow(Math.max(0, Math.min(1, linear)), FROST_GROWTH_CURVE);
    controllerFrostLayer?.update(frostProgress);
    controllerFrostOverlay.classList.toggle('frost-active', frostProgress > 0.01);
  }

  if (controllerHeatOverlay) {
    const heatClearRadius = Math.max(0, Math.min(100, (100 - snapshot.submarine.insideTemperature) * 2.5));
    controllerHeatOverlay.style.setProperty('--heat-clear-radius', `${heatClearRadius}%`);
    controllerHeatOverlay.classList.toggle('heat-active', snapshot.submarine.insideTemperature > 60);
  }
};

